import { LockClosedIcon } from '@heroicons/react/24/outline';
import { SolidStatusPill } from '../../components/SolidStatusPill';
import { TeamPill } from '../../components/TeamPill';
import {
    VIRTUAL_APPOINTMENT_STATUS_LABELS,
    formatSummaryTrigger,
    isFrozenSummary,
    type VirtualAppointmentSummary
} from './summary';
import { VirtualAppointmentTypeTitle } from './VirtualAppointmentTypeTitle';

interface VirtualAppointmentRowProps {
    summary: VirtualAppointmentSummary;
    /** Compact rows drop the description and the card chrome (recaps, dense lists). */
    compact?: boolean;
}

export function VirtualAppointmentRow({ summary, compact = false }: VirtualAppointmentRowProps) {
    const chrome = compact ? 'py-1.5' : 'rounded-xl border border-gray-200 bg-gray-50 px-4 py-3';

    return (
        <div className={`flex flex-col gap-1 ${chrome}`}>
            <div className="flex items-center justify-between gap-3 min-w-0">
                <span className="flex items-center gap-1.5 min-w-0 text-sm">
                    {isFrozenSummary(summary) && (
                        <LockClosedIcon
                            className="w-3.5 h-3.5 flex-shrink-0 text-gray-400"
                            aria-label="Read-only"
                        />
                    )}
                    <VirtualAppointmentTypeTitle
                        summary={summary}
                        codeClassName="font-semibold text-gray-800"
                    />
                </span>
                <SolidStatusPill
                    value={summary.status}
                    label={VIRTUAL_APPOINTMENT_STATUS_LABELS[summary.status]}
                    compact
                    className="flex-shrink-0"
                />
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-600">
                <span className="whitespace-nowrap">{formatSummaryTrigger(summary)}</span>
                <TeamPill team={summary.team} size="xs" />
            </div>
            {!compact && summary.description && (
                <p className="text-sm text-gray-600 line-clamp-2 whitespace-pre-wrap">
                    {summary.description}
                </p>
            )}
        </div>
    );
}
